import http from '@/http'
export default {
  downloadPdf: function (bookId, isPreview) {
    var self = this
    http.post('/book/download/', {'id': bookId}).then(function (response) {
      self.downloadOrPreviewFile_(response, isPreview)
    })
  },
  downloadEpub: function (bookId) {
    var self = this
    http.post('/book/epub/', {'id': bookId}).then(function (response) {
      self.downloadOrPreviewFile_(response, false)
    })
  },
  downloadOrPreviewFile_: function (response, isPreview) {
    console.log(response)
    var file = response.body

    var bin = atob(file.base64.replace(/^.*,/, ''))
    var buffer = new Uint8Array(bin.length)
    for (var i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i)
    }
    var blob = new Blob([ buffer.buffer ], { 'type': file.mime })

    if (window.navigator.msSaveBlob) {
      // for IE
      if (isPreview) {
        alert('このブラウザはプレビューに対応していません')
      } else {
        window.navigator.msSaveBlob(blob, file.name)
      }
    } else {
      window.URL = window.URL || window.webkitURL
      var blobUrl = window.URL.createObjectURL(blob)

      var a = document.createElement('a')
      a.download = file.name

      if (isPreview) {
        window.open(blobUrl, "target='_blank'")
      } else if (window.navigator.appVersion.indexOf('Safari') > -1) {
        // for Safari, Chrome
        a.href = blobUrl
        a.click()
      } else {
        // for Firefox
        a.href = blobUrl
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/global/fileutil.js